import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { GoogleAuthSetupStepComponent } from 'app/components/v2-layout/shared/two-factor-setup-steps/google-auth-setup-step.component';
import { RECOVERY_CODES_GATE_COPY } from 'app/components/v2-layout/shared/two-factor-gate-dialog/two-factor-gate-dialog.component';

/**
 * Settings → Security wrapper: hosts the shared {@link GoogleAuthSetupStepComponent}
 * inside a dialog so authenticator enrollment is identical to the 2FA gate stepper and
 * the enrollment logic lives in exactly one place. Preserves the existing
 * open()/afterClosed contract — resolves `{success: true}` once enrolled and `undefined`
 * on cancel — so the Settings tab is unchanged (SD-8102).
 */
@Component({
    selector: 'app-setup-google-authenticator',
    templateUrl: './setup-google-authenticator.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatDialogModule,
        GoogleAuthSetupStepComponent,
    ],
})
export class SetupGoogleAuthenticatorComponent
{
    constructor(private _dialogRef: MatDialogRef<SetupGoogleAuthenticatorComponent>) {
    }

    /** Dialog heading — swaps when the step reaches its show-once recovery-codes stage. */
    title = 'Enable Google Authenticator';

    /**
     * The codes render inside this dialog, so the heading describes them rather than enrollment.
     *
     * Also locks the dialog: the method is enrolled and the codes generated by this point, so an
     * ESC or backdrop click would discard the only view of them. Dismissal stays available for the
     * enrollment stages before this.
     */
    onShowingRecoveryCodes(): void {
        this.title = RECOVERY_CODES_GATE_COPY.title;
        this._dialogRef.disableClose = true;
    }

    onCompleted(): void {
        this._dialogRef.close({success: true});
    }

    onCancelled(): void {
        this._dialogRef.close();
    }
}
